export { FullWidthImage } from './full-width-image'
